import { Action } from 'redux';
import * as ConfigActions from './config.actions';

export interface ConfigState {
    config;
}

const initialState: ConfigState = {
    config: {
        region: undefined,
        logoUrl: undefined,//Utility.GetHost((environment.cinema == 1? '//static.{Host}/images/rv20/gl.png?v=3':"//static.{Host}/images/rv15/wyav40.png")),
    }
};

export const ConfigReducer =
    function (state: ConfigState = initialState, action: Action): ConfigState {
        switch (action.type) {
            case ConfigActions.CLEAR:
                return initialState;
            case ConfigActions.UPDATEREGION:
                const updateRegionState = Object.assign({}, state);
                const newRegion: string = (<ConfigActions.UpdateRegionAction>action).config.region;
                updateRegionState.config.region = newRegion;
                updateRegionState.config.logoUrl = (<ConfigActions.UpdateRegionAction>action).config.logoUrl;
                return updateRegionState;
            // case ConfigActions.CHANGEGUESTLISTOPENSTATUS:
            //     const updateGuestListOpenState = Object.assign({}, state);
            //     updateGuestListOpenState.config.guestListOpenStatus = (<ConfigActions.ChangeGuestListOpenStatusAction>action).status;
            //     return updateGuestListOpenState;
            // case ConfigActions.CHANGEVIPLISTOPENSTATUS:
            //     const updateVipListOpenState = Object.assign({}, state);
            //     updateVipListOpenState.config.vipListOpenStatus = (<ConfigActions.ChangeVipListOpenStatusAction>action).status;
            //     return updateVipListOpenState;
            // case ConfigActions.ALLVIP:
            //     const allVipState = Object.assign({}, state);
            //     allVipState.config.allVip = true;
            //     return allVipState;
            default:
                return state;
        }
    };

export const getCommentsState = (state): ConfigState => state.config;
